export const categoryVideos: Record<string, {
  id: number;
  title: string;
  category: string;
  categorySlug: string;
  duration: string;
  views: number;
  rating: number;
  thumbnail: string;
  description: string;
  date: string;
}[]> = {
  dianying: [
    {
      id: 1,
      title: '《流浪地球3》官方预告片首发',
      category: '电影',
      categorySlug: 'dianying',
      duration: '3:25',
      views: 1285000,
      rating: 9.2,
      thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20with%20planet%20engine%20in%20deep%20space%2C%20dramatic%20orange%20and%20teal%20lighting%2C%20cinematic%20composition%2C%20epic%20scale&width=640&height=360&seq=cat-movie-01&orientation=landscape',
      description: '继前两部创下票房纪录后，《流浪地球3》再度回归，太阳急速老化膨胀，人类面临前所未有的生存危机。',
      date: '2026-08-10',
    },
    {
      id: 7,
      title: '《封神第二部》终极预告曝光',
      category: '电影',
      categorySlug: 'dianying',
      duration: '2:48',
      views: 756000,
      rating: 8.8,
      thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20fantasy%20film%20with%20ancient%20warriors%20in%20elaborate%20armor%2C%20epic%20battle%20formation%2C%20golden%20clouds%2C%20cinematic%20lighting&width=640&height=360&seq=cat-movie-02&orientation=landscape',
      description: '封神宇宙第二部重磅来袭，三界大战一触即发，视效全面升级，剧情层层递进。',
      date: '2026-08-10',
    },
    {
      id: 13,
      title: '《速度与激情11》中文预告',
      category: '电影',
      categorySlug: 'dianying',
      duration: '2:30',
      views: 965000,
      rating: 8.5,
      thumbnail: 'https://readdy.ai/api/search-image?query=High%20speed%20car%20chase%20action%20movie%20scene%20with%20sports%20cars%20in%20city%2C%20dramatic%20sunset%20lighting%2C%20explosive%20cinematic%20style&width=640&height=360&seq=cat-movie-03&orientation=landscape',
      description: '全球最卖座赛车系列最新力作，极限飙车场面升级，老友重聚新敌登场。',
      date: '2026-08-09',
    },
    {
      id: 14,
      title: '《姜子牙2》动画大电影定档',
      category: '电影',
      categorySlug: 'dianying',
      duration: '1:55',
      views: 1230000,
      rating: 9.0,
      thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20fantasy%20film%20scene%20with%20mythological%20character%20fishing%2C%20beautiful%20celestial%20realm%2C%20ethereal%20golden%20lighting%2C%20artistic%20style&width=640&height=360&seq=cat-movie-04&orientation=landscape',
      description: '光线彩条屋影业打造国风动画巅峰之作，姜子牙再踏封神之旅，画面精美绝伦。',
      date: '2026-08-08',
    },
    {
      id: 15,
      title: '《寂静岭》重启版概念预告',
      category: '电影',
      categorySlug: 'dianying',
      duration: '2:15',
      views: 523000,
      rating: 7.9,
      thumbnail: 'https://readdy.ai/api/search-image?query=Eerie%20foggy%20small%20town%20horror%20film%20scene%2C%20abandoned%20street%20with%20mist%2C%20cold%20atmospheric%20lighting%2C%20psychological%20thriller%20cinematic%20style&width=640&height=360&seq=cat-movie-05&orientation=landscape',
      description: '经典恐怖游戏改编电影重启，全新演员阵容，忠实还原游戏中的压抑氛围与心理恐惧。',
      date: '2026-08-07',
    },
    {
      id: 16,
      title: '《哪吒之魔童闹海》续作官宣',
      category: '电影',
      categorySlug: 'dianying',
      duration: '1:40',
      views: 2890000,
      rating: 9.8,
      thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20with%20rebellious%20child%20deity%20character%20in%20epic%20pose%2C%20flaming%20elements%2C%20dramatic%20red%20and%20gold%20color%20scheme%2C%20mythological%20style&width=640&height=360&seq=cat-movie-06&orientation=landscape',
      description: '现象级国漫续作官宣启动，原班制作团队回归，哪吒将迎来全新的冒险与挑战。',
      date: '2026-08-06',
    },
  ],
  dianshiju: [
    {
      id: 2,
      title: '《长安十二时辰》续集定档',
      category: '电视剧',
      categorySlug: 'dianshiju',
      duration: '45:20',
      views: 985000,
      rating: 9.5,
      thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20cityscape%20night%20with%20lanterns%2C%20traditional%20architecture%2C%20warm%20golden%20lighting%2C%20historical%20drama%20cinematic%20style&width=640&height=360&seq=cat-drama-01&orientation=landscape',
      description: '备受期待的《长安十二时辰》续集终于定档，原班人马再度集结，展开全新篇章的悬疑故事。',
      date: '2026-08-09',
    },
    {
      id: 8,
      title: '《狂飙》导演新作《暗涌》开播',
      category: '电视剧',
      categorySlug: 'dianshiju',
      duration: '42:15',
      views: 623000,
      rating: 9.1,
      thumbnail: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20Chinese%20drama%20night%20scene%2C%20detective%20in%20coat%2C%20rainy%20street%20neon%20reflections%2C%20noir%20lighting%2C%20suspenseful&width=640&height=360&seq=cat-drama-02&orientation=landscape',
      description: '《狂飙》导演最新力作，聚焦金融犯罪领域，一场资本与正义的博弈即将展开。',
      date: '2026-08-10',
    },
    {
      id: 17,
      title: '《琅琊榜3》开机发布会全程',
      category: '电视剧',
      categorySlug: 'dianshiju',
      duration: '58:30',
      views: 1450000,
      rating: 9.6,
      thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20scene%20with%2C%20ancient%20Chinese%20palace%20courtyard%2C%20elegant%20traditional%20architecture%2C%20warm%20cinematic%20lighting&width=640&height=360&seq=cat-drama-03&orientation=landscape',
      description: '正午阳光出品，琅琊榜系列第三部正式开机，新老演员齐聚，再续权谋传奇。',
      date: '2026-08-08',
    },
    {
      id: 18,
      title: '《大江大河3》首播特辑',
      category: '电视剧',
      categorySlug: 'dianshiju',
      duration: '40:00',
      views: 680000,
      rating: 9.3,
      thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20era%20drama%20industrial%20factory%20scene%2C%20workers%20and%20machinery%2C%20warm%20golden%20hour%20lighting%2C%20historical%20atmosphere&width=640&height=360&seq=cat-drama-04&orientation=landscape',
      description: '改革开放题材扛鼎之作回归，宋运辉、雷东宝的故事继续书写时代变迁的大江大河。',
      date: '2026-08-06',
    },
  ],
  zongyi: [
    {
      id: 3,
      title: '《歌手2026》总决赛巅峰对决',
      category: '综艺',
      categorySlug: 'zongyi',
      duration: '120:00',
      views: 2100000,
      rating: 9.0,
      thumbnail: 'https://readdy.ai/api/search-image?query=Grand%20music%20stage%20spotlights%20dramatic%20lighting%2C%20singer%20performing%20center%20stage%2C%20concert%20atmosphere%20audience%2C%20warm%20golden%20red%20tones&width=640&height=360&seq=cat-variety-01&orientation=landscape',
      description: '八位顶尖歌手同台竞技，用歌声征服全场观众，本季歌王即将揭晓。',
      date: '2026-08-08',
    },
    {
      id: 9,
      title: '《密室大逃脱》新一季重磅回归',
      category: '综艺',
      categorySlug: 'zongyi',
      duration: '68:30',
      views: 510000,
      rating: 8.5,
      thumbnail: 'https://readdy.ai/api/search-image?query=Mysterious%20escape%20room%20set%20puzzle%20elements%20dramatic%20lighting%2C%20team%20solving%20clues%2C%20immersive%20atmosphere%2C%20warm%20dim%20ambient&width=640&height=360&seq=cat-variety-02&orientation=landscape',
      description: '烧脑升级，机关更复杂，嘉宾阵容全新升级，密室大逃脱新一季等你来挑战。',
      date: '2026-08-09',
    },
  ],
  dongman: [
    {
      id: 4,
      title: '《鬼灭之刃》剧场版全球首映',
      category: '动漫',
      categorySlug: 'dongman',
      duration: '98:00',
      views: 3560000,
      rating: 9.8,
      thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20demon%20slayer%20battle%20scene%20water%20breathing%2C%20dynamic%20action%2C%20vibrant%20blue%20red%20energy%2C%20Japanese%20art%20style%2C%20cherry%20blossoms&width=640&height=360&seq=cat-anime-01&orientation=landscape',
      description: '人气动漫《鬼灭之刃》全新剧场版全球同步首映，炭治郎与伙伴们迎来最强大的敌人。',
      date: '2026-08-07',
    },
    {
      id: 10,
      title: '《进击的巨人》最终季完结篇',
      category: '动漫',
      categorySlug: 'dongman',
      duration: '85:00',
      views: 4200000,
      rating: 9.6,
      thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20colossal%20titan%20dramatic%20destruction%2C%20steam%20smoke%2C%20intense%20orange%20sunset%20sky%2C%20epic%20anime%20cinematography&width=640&height=360&seq=cat-anime-02&orientation=landscape',
      description: '十年连载终落幕，巨人最终季完结篇震撼播出，一切谜题都将揭晓。',
      date: '2026-08-08',
    },
  ],
  jilupian: [
    {
      id: 5,
      title: '《地球脉动III》深海秘境特辑',
      category: '纪录片',
      categorySlug: 'jilupian',
      duration: '58:30',
      views: 685000,
      rating: 9.7,
      thumbnail: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20documentary%20bioluminescent%20creatures%20coral%20reef%2C%20whale%20silhouette%2C%20ethereal%20lighting%2C%20BBC%20nature%20style&width=640&height=360&seq=cat-doc-01&orientation=landscape',
      description: 'BBC金牌制作团队历时五年打造，深入从未被拍摄过的深海秘境。',
      date: '2026-08-06',
    },
  ],
  tiyu: [
    {
      id: 6,
      title: 'NBA季后赛：湖人vs勇士精彩回放',
      category: '体育',
      categorySlug: 'tiyu',
      duration: '25:40',
      views: 890000,
      rating: 8.9,
      thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20game%20action%20player%20dunking%2C%20dramatic%20arena%20lighting%2C%20crowd%20energy%2C%20NBA%20playoff%20atmosphere&width=640&height=360&seq=cat-sports-01&orientation=landscape',
      description: '两大豪门球队季后赛狭路相逢，全场高能不断，最后一秒绝杀引爆全场。',
      date: '2026-08-05',
    },
  ],
  yinyue: [
    {
      id: 11,
      title: '柴可夫斯基《天鹅湖》全剧高清',
      category: '音乐',
      categorySlug: 'yinyue',
      duration: '135:00',
      views: 320000,
      rating: 9.4,
      thumbnail: 'https://readdy.ai/api/search-image?query=Ballet%20Swan%20Lake%20grand%20stage%2C%20ballerinas%20white%20tutus%2C%20elegant%20spotlight%2C%20classical%20arts%20atmosphere%2C%20refined%20composition&width=640&height=360&seq=cat-music-01&orientation=landscape',
      description: '马林斯基剧院经典版本，世界顶级芭蕾舞团演绎柴可夫斯基不朽传世之作。',
      date: '2026-08-07',
    },
  ],
  youxi: [
    {
      id: 12,
      title: '《黑神话：悟空》资料片实机演示',
      category: '游戏',
      categorySlug: 'youxi',
      duration: '18:20',
      views: 1890000,
      rating: 9.3,
      thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20game%2C%20monkey%20warrior%20ancient%20armor%2C%20bamboo%20forest%20sunlight%2C%20photorealistic%20graphics%2C%20dynamic%20combat&width=640&height=360&seq=cat-game-01&orientation=landscape',
      description: '国产3A大作《黑神话：悟空》首个资料片实机画面曝光，全新地图与BOSS震撼登场。',
      date: '2026-08-06',
    },
  ],
};

export const articleVideos: Record<number, {
  id: number;
  title: string;
  category: string;
  categorySlug: string;
  duration: string;
  views: number;
  rating: number;
  thumbnail: string;
  description: string;
  content: string;
  date: string;
  relatedIds: number[];
}> = {};

// Build article data from hot and latest videos
import { hotVideos, latestVideos } from './home';

const allVid = [...hotVideos, ...latestVideos];
allVid.forEach((v) => {
  articleVideos[v.id] = {
    ...v,
    content: `<p>${v.description}</p><p>该视频资源由蜜桃在线平台提供高清流畅播放服务。我们的内容团队每日精选全网最优质的视频资源，确保您能第一时间观看到最新、最热门的影视内容。</p><p>蜜桃在线支持4K超高清画质、多终端同步播放、离线缓存等特色功能。注册会员还可享受无广告纯净观影、超前点播等专属权益。</p><p>立即注册蜜桃在线会员，解锁更多精彩内容！</p>`,
    relatedIds: allVid.filter((x) => x.id !== v.id && x.categorySlug === v.categorySlug).slice(0, 3).map((x) => x.id),
  };
});

// Also build from category videos
Object.values(categoryVideos).forEach((videos) => {
  videos.forEach((v) => {
    if (!articleVideos[v.id]) {
      articleVideos[v.id] = {
        ...v,
        content: `<p>${v.description}</p><p>该视频资源由蜜桃在线平台提供高清流畅播放服务。我们的内容团队每日精选全网最优质的视频资源，确保您能第一时间观看到最新、最热门的影视内容。</p><p>蜜桃在线支持4K超高清画质、多终端同步播放、离线缓存等特色功能。注册会员还可享受无广告纯净观影、超前点播等专属权益。</p><p>立即注册蜜桃在线会员，解锁更多精彩内容！</p>`,
        relatedIds: videos.filter((x) => x.id !== v.id).slice(0, 3).map((x) => x.id),
      };
    }
  });
});